import script from "./DepoimentosCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepoimentosCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./DepoimentosCarousel.vue?vue&type=style&index=0&id=508106a0&lang=css"

const __exports__ = script;

export default __exports__